import React, { useState } from 'react';
import InputText from './InputText';

function RangoPrecios({ setFiltros }) {
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'min') {
      setMin(value);
    } else if (name === 'max') {
      setMax(value);
    }
  };

  const handleAplicar = () => {
    setFiltros((prevFiltros) => ({
      ...prevFiltros,
      min: min ? parseFloat(min) : 0,
      max: max ? parseFloat(max) : 0,
    }));
  };

  return (
    <div className='w-full mt-10 flex flex-col p-2'>
      <label className='font-bold text-sm xl:text-base'>Rangos de Precios</label>
      <div className='w-full justify-evenly mt-2 flex flex-col items-center p-2'>
        <div className='w-full flex flex-col items-center xl:flex-row'>
          <InputText placeholder="min" name="min" value={min} onChange={handleChange} />
          <label className='font-bold text-xl mx-2'>-</label>
          <InputText placeholder="máx" name="max" value={max} onChange={handleChange} />
        </div>
        <div className='w-4/5 xl:w-2/5 flex justify-center bg-Verde p-1 rounded-xl mt-5'>
          <button className='text-Blanco xl:font-bold' onClick={handleAplicar}>
            Aplicar
          </button>
        </div>
      </div>
    </div>
  );
}

export default RangoPrecios;
